import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function SecureHeader() {
  return <header className="sticky top-0 z-50 bg-warm-white/95 backdrop-blur-sm border-b border-almond-milk" data-id="element-103">
      <div className="max-w-lg mx-auto px-4 py-4 flex items-center justify-between" data-id="element-104">
        <div className="flex items-center gap-2" data-id="element-105">
          <div className="text-lg font-bold text-deep-cocoa" data-id="element-106">
            Gana500TikTokShop
          </div>
        </div>

        <div className="flex items-center gap-1.5 text-xs text-deep-cocoa/80" data-id="element-107">
          <ShieldCheckIcon className="w-4 h-4 text-champagne-gold" data-id="element-108" />
          <span className="font-medium" data-id="element-109">Pago 100% seguro</span>
        </div>
      </div>
    </header>;
}